const Lock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill="#222"
      fillRule="evenodd"
      d="M22.844 15.152h-.314v-2.736C22.53 8.879 19.602 6 15.998 6c-3.6 0-6.532 2.875-6.532 6.416a.59.59 0 0 0 .598.587.59.59 0 0 0 .598-.587c0-2.888 2.39-5.242 5.336-5.242 2.94 0 5.336 2.35 5.336 5.242v2.736H9.156c-.638 0-1.156.509-1.156 1.135v7.312C8 25.473 9.554 27 11.463 27h9.074C22.446 27 24 25.473 24 23.599v-7.312c0-.626-.518-1.135-1.156-1.135Zm-.04 8.447c0 1.226-1.014 2.227-2.267 2.227h-9.07c-1.248 0-2.267-.997-2.267-2.227v-7.273h13.604v7.273Z"
      clipRule="evenodd"
    />
    <path
      fill="#222"
      fillRule="evenodd"
      d="M16 23c1.105 0 2-.899 2-2 0-1.105-.899-2-2-2-1.105 0-2 .899-2 2s.895 2 2 2Zm0-2.935a.932.932 0 0 1 0 1.866.932.932 0 0 1 0-1.866Z"
      clipRule="evenodd"
    />
  </svg>
)
export { Lock }
